"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const SiteListTitle_1 = __importDefault(require("../SiteListTitle"));
const SiteListRow_1 = __importDefault(require("../SiteListRow"));
const SystemsToast_1 = __importDefault(require("../SystemsToast"));
const LoadingSection_1 = __importDefault(require("./LoadingSection"));
const SiteToast_1 = __importDefault(require("../SiteToast"));
function SitesListView({ sites, isLoading }) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(SiteListTitle_1.default, null),
        isLoading ? (react_1.default.createElement(LoadingSection_1.default, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            sites.map((site, i) => {
                return (react_1.default.createElement(SiteListRow_1.default, { key: i, siteName: site.name, siteId: site.id, systems: site.systemsList }));
            }),
            react_1.default.createElement(SystemsToast_1.default, null),
            react_1.default.createElement(SiteToast_1.default, null)))));
}
exports.default = SitesListView;
